module.exports = __webpack_public_path__ + "img/niu5.1e3e646e.jpg";